(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root) {
    if (root.dataset.yesskinReady) return;
    root.dataset.yesskinReady = 'true';
    const cleanup = [];
    root.querySelectorAll('[data-amai-question]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('.uv-acc__item');
        const open = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', String(open));
      });
    });
    const ticker = root.querySelector('.amai-ysk-ticker');
    const header = document.querySelector('header.header-section');
    if (ticker && header) header.before(ticker);
    const styleBanner = () => {
      document.querySelectorAll('.gta-bar:not([data-amai-styled])').forEach(bar => {
        bar.dataset.amaiStyled = 'true';
        bar.style.setProperty('background', 'linear-gradient(90deg,#dcebb4,#f6e3d0,#dcebb4)', 'important');
        bar.querySelectorAll('[style]').forEach(el => {
          if (el.style.backgroundImage?.includes('linear-gradient')) el.style.setProperty('background', 'transparent', 'important');
        });
      });
    };
    styleBanner();
    const bannerObserver = new MutationObserver(styleBanner);
    bannerObserver.observe(document.body, {childList:true, subtree:true});
    cleanup.push(() => bannerObserver.disconnect());
    const brand = root.querySelector('[data-amai-yesskin-brand]');
    if (brand && header) {
      const mountBrand = () => { if (!header.contains(brand)) header.append(brand); };
      mountBrand();
      const brandObserver = new MutationObserver(mountBrand);
      brandObserver.observe(header, {childList:true, subtree:true});
      cleanup.push(() => brandObserver.disconnect());
    }
    const revealSelectors = '.amai-ysk-intro h1,.amai-ysk-intro .eyebrow,.rating,.amai-ysk-offer,.amai-guarantee,.amai-subscribe,.skin-heading,.skin-visual,.skin-content,.ugc-head,.ugc-card,.section>.shell>h2,.section>.shell>.sub,.routine-card,.review-card,.ingredient,.final-card,.amai-new-intro,.amai-stock,.uv-tl__head,.uv-tl__list li,.uv-cmp__table,.amai-new-guarantee .uv-gtee__card';
    const reveals = [...root.querySelectorAll(revealSelectors)];
    if (!reduced && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      }, {threshold: .12, rootMargin: '0px 0px -30px 0px'});
      const groups = new Map();
      reveals.forEach(el => {
        const count = groups.get(el.parentElement) || 0;
        groups.set(el.parentElement, count + 1);
        el.setAttribute('data-uv-reveal', el.matches('.skin-visual,.ingredient') ? 'zoom' : '');
        el.style.setProperty('--i', Math.min(count, 6));
        observer.observe(el);
      });
      root.classList.add('uv-js');
      cleanup.push(() => observer.disconnect());
    }
    const heroTrack = root.querySelector('[data-hero-gallery-track]');
    if (heroTrack) {
      const slides = [...heroTrack.querySelectorAll('[data-hero-gallery-slide]')];
      let frame = 0;
      const update = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const left = heroTrack.getBoundingClientRect().left;
          let active = 0, distance = Infinity;
          slides.forEach((slide, i) => { const delta = Math.abs(slide.getBoundingClientRect().left - left); if (delta < distance) { distance = delta; active = i; } });
          slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
        });
      };
      heroTrack.addEventListener('scroll', update, {passive: true});
      update();
      cleanup.push(() => { heroTrack.removeEventListener('scroll', update); cancelAnimationFrame(frame); });
    }
    root.querySelectorAll('[data-slider],.ingredient-grid').forEach(track => {
      if (track.dataset.slider === 'routine') return;
      const slides = [...track.children];
      if (slides.length < 2) return;
      const nav = document.createElement('div');
      nav.className = 'amai-ysk-dashes';
      const dots = slides.map((slide, i) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `${i + 1} / ${slides.length}`);
        button.addEventListener('click', () => track.scrollTo({left: slide.offsetLeft - track.firstElementChild.offsetLeft, behavior: reduced ? 'auto' : 'smooth'}));
        nav.append(button);
        return button;
      });
      track.after(nav);
      let raf = 0;
      const update = () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const left = track.getBoundingClientRect().left;
          let active = 0, distance = Infinity;
          slides.forEach((slide, i) => { const delta = Math.abs(slide.getBoundingClientRect().left - left); if (delta < distance) { distance = delta; active = i; } });
          dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === active); dot.setAttribute('aria-current', i === active ? 'true' : 'false'); });
        });
      };
      track.addEventListener('scroll', update, {passive:true});
      update();
      cleanup.push(() => { track.removeEventListener('scroll', update); cancelAnimationFrame(raf); nav.remove(); });
    });
    const float = root.querySelector('.uv-float__prod');
    const timeline = [...root.querySelectorAll('[data-slider="routine"] .routine-card,[data-amai-stage]')];
    let motionFrame = 0;
    const updateMotion = () => {
      const mainButton = root.querySelector('[data-main-atc]');
      const sticky = root.querySelector('[data-sticky]');
      if (mainButton && sticky) sticky.classList.toggle('is-visible', mainButton.getBoundingClientRect().bottom < 0);
      if (reduced || motionFrame) return;
      motionFrame = requestAnimationFrame(() => {
        motionFrame = 0;
        if (float) {
          const bounds = float.parentElement.getBoundingClientRect();
          if (bounds.bottom > -100 && bounds.top < innerHeight + 100) {
            const distance = (innerHeight * .5 - bounds.top - bounds.height * .5) * .12;
            float.style.setProperty('--py', `${Math.max(-60, Math.min(60, distance))}px`);
          }
        }
        timeline.forEach(card => {
          const bounds = card.getBoundingClientRect();
          const progress = Math.max(0, Math.min(1, (innerHeight * .75 - bounds.top) / bounds.height));
          card.style.setProperty('--p', progress);
        });
      });
    };
    window.addEventListener('scroll', updateMotion, {passive:true});
    updateMotion();
    cleanup.push(() => { window.removeEventListener('scroll', updateMotion); cancelAnimationFrame(motionFrame); });
    const handleUnload = event => {
      if (!event.target.contains(root)) return;
      cleanup.forEach(fn => fn());
      ticker?.remove();
      brand?.remove();
      document.removeEventListener('shopify:section:unload', handleUnload);
    };
    document.addEventListener('shopify:section:unload', handleUnload);
  }
  document.querySelectorAll('.amai-yesskin').forEach(init);
  if (!window.amaiYesskinEditorBound) {
    window.amaiYesskinEditorBound = true;
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.amai-yesskin').forEach(init));
  }
})();

